import 'angular';

import { downgradeComponent } from '@angular/upgrade/static';

import { IconComponent }    from './icon/icon.component';
import { ListBoxComponent } from './list-box/list-box.component';

angular.module('app-lite.shared.components', [])
.directive('listBox', downgradeComponent({ component: ListBoxComponent }))
.directive('worIcon', downgradeComponent({ component: IconComponent }));